<script lang="ts">
  export let value
</script>

{#each value as _}
  <br />
{/each}
